import type { DetectionCategory } from "@aimosaic/core";

export function shouldRunDetailedUrlOcr(
  deepSearch: boolean,
  categories: readonly DetectionCategory[]
): boolean {
  if (!categories.includes("url")) return false;
  return deepSearch;
}
